<template>
	<div>
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>

		<div class="export-popi export-po-pdf">
			<h1>Export PO</h1>

			<p class="description">
				This page will export selected PO in PDF or CSV format.
			</p>
			<div class="po-export-divider">
				<div>
					<b-field label="PO Number">
						<b-input v-model="poCode" placeholder="PO Number" @keyup.native.enter="exportPo"></b-input>
					</b-field>

					<div class="button-container">
						<div class="big-button" @click="exportPo()">
							Load PO Number
						</div>
					</div>
				</div>

				<div>
					<strong>Export CSV</strong>
					<br />
					<b-radio v-model="exportType" name="name" native-value="all">All POs</b-radio>
					<b-radio v-model="exportType" name="name" native-value="outstanding">Outstanding Only</b-radio>
					<br />
					<br />

					<b-field label="Select Brand (required)" v-if="displayBrand">
						<b-autocomplete
							v-model="brandSuggestions"
							:data="filteredBrands"
							:open-on-focus="true"
							placeholder="Brand"
							field="code"
							@select="option => (selectedBrand = option)"
							class="brandAutocomplete"
						>
							<template slot="empty">No results found</template>
						</b-autocomplete>
					</b-field>

					<b-field label="Starting Date (required)">
						<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="fromDate" icon="calendar-today">
							<button class="button is-primary" @click="fromDate = new Date()">
								<b-icon icon="calendar-today"></b-icon>
								<span>Today</span>
							</button>

							<button class="button is-danger" @click="fromDate = null">
								<b-icon icon="close"></b-icon>
								<span>Clear</span>
							</button>
						</b-datepicker>
					</b-field>

					<b-field label="Ending Date (required)">
						<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="toDate" icon="calendar-today" :min-date="minDate">
							<button class="button is-primary" @click="toDate = new Date()">
								<b-icon icon="calendar-today"></b-icon>
								<span>Today</span>
							</button>

							<button class="button is-danger" @click="toDate = null">
								<b-icon icon="close"></b-icon>
								<span>Clear</span>
							</button>
						</b-datepicker>
					</b-field>

					<div class="button-container">
						<div class="big-button" @click="exportMultiplePo()">
							Load PO
						</div>
					</div>
				</div>
			</div>

			<div v-if="progress > 0">
				<br /><br />
				<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
			</div>
		</div>

		<div class="button-container export-pdf-button" v-if="multiplePo.length > 0">
			<div class="big-button" @click="export_csv()">
				EXPORT CSV
			</div>
		</div>

		<div class="button-container export-pdf-button" v-if="multiplePo.length > 0 && exportType !== 'outstanding'">
			<div class="big-button" @click="print()">
				SAVE PDF FILE
			</div>
		</div>

		<div id="printing" v-if="multiplePo.length > 0 && exportType == 'all'">
			<div v-for="(poDetail, index) of multiplePo" v-bind:key="index">
				<div v-if="poDetail.purchase_order.status == true && poDetail.purchase_order.disable == false">
					<div class="logo">
						<img class="logo" src="../assets/bdlogo.png" />
					</div>

					<div class="order-details-wrapper">
						<div class="order-details">
							<h1>ORDER</h1>
							<span>ORDER ID: {{ poDetail.purchase_order.code }}</span>
							<br />
							<span>ORDER DATE: {{ convertTime(poDetail.purchase_order_items[0].order_date) }}</span>
							<br />
							<span>EXPECTED DATE: {{ convertTime(poDetail.purchase_order_items[0].expected_date) }}</span>
							<br />
							<span>BRAND: {{ poDetail.purchase_order.brand.name }}</span>
							<br />
							<span>{{ getLocationLabel(poDetail.purchase_order) }}: {{ getLocationName(poDetail.purchase_order) }}</span>
						</div>
						<div class="order-details">
							<br /><br />
							<span>MAIN OFFICE ADDRESS:</span>
							<br />
							<span>No. 92(A) , U Aung Kain Street, <br />Than Lwin Road, Golden Valley 1</span>
						</div>
					</div>

					<div class="order-items-wrapper">
						<div class="order-items header">
							<span>
								No.
							</span>
							<span>
								DESCRIPTION
							</span>
							<span>
								BD CODE
							</span>
							<span>
								BARCODE
							</span>
							<span>
								PRICE
							</span>
							<span>
								QUANTITY
							</span>
							<span class="amount">
								AMOUNT
							</span>
						</div>

						<div class="order-items" v-for="(item, index) of poDetail.purchase_order_items" v-bind:key="index">
							<!-- <div v-if="Number.isInteger(index / 10)">
								<div class="page-break"></div>
							</div> -->
							<span>
								{{ index + 1 }}
							</span>
							<span>
								{{ item.product.name }}
								<br />
								<span class="export-order-id">{{ getLocationName(poDetail.purchase_order) }}</span>
							</span>
							<span>
								{{ item.product.bd_code }}
							</span>
							<span>
								{{ item.product.barcode }}
							</span>
							<span>
								{{ getItemAmount(item) }}
							</span>
							<span>
								{{ item.qty }}
								<br />
								<!-- Display packaging selection below quantity with lighter font -->
								<span class="packaging-text">{{ getPackagingSelection(item) }}</span>
							</span>
							<span class="amount">
								{{ getTotalAmount(item) }}
							</span>
						</div>
					</div>

					<div class="order-items">
						<span> </span>
						<span> </span>
						<span> </span>
						<span> </span>

						<span class="total">
							TOTAL
						</span>
						<span class="total">
							{{ poDetail.totalQuantity }}
						</span>
						<span class="amount total">
							{{ poDetail.orderTotal.toLocaleString('en-GB') }}
						</span>
					</div>
					<div class="page-break"></div>
				</div>
				<!-- end of v-if -->
			</div>
		</div>
	</div>
</template>

<script>
import { Printd } from 'printd'

export default {
	name: 'ExportPoPDF',
	data: function() {
		return {
			isLoading: false,
			poCode: null,
			poDetail: null,
			orderTotal: null,
			brands: [],
			selectedBrand: null,
			brandSuggestions: '',
			fromDate: null,
			toDate: null,
			minDate: null,
			multiExport: false,
			multiplePo: [],
			poList: [],
			exportType: 'all',
			displayBrand: true,
			progress: 0,
			cssText: `#printing {
	font-family: "Segoe UI", "Calibri", "Arial";
  width: 1000px;
  margin: auto;
  padding: 20px;
}

#printing .logo {
  width: 300px;
  text-align: left;
}

#printing .order-details-wrapper {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr 300px;
  grid-gap: 10px;
}

#printing .order-details {
  padding: 10px;
  text-align: left;
}

#printing .export-order-id {
	font-weight: bold;
	font-size: 12px;
	color: #999;
	text-align: left;
	border-top: none;
}

#printing .order-details h1 {
  font-weight: bold;
  font-size: 30px;
}

#printing .order-items {
  display: grid;
  grid-template-columns: 50px 1fr 100px 150px 100px 70px 100px;
  grid-gap: 10px;
  padding: 15px 5px;
  font-size: 16px;
  border-top: 1px solid #ccc;
}

#printing .order-items-wrapper {
  text-align: left;
  margin-top: 20px;
  border-top: 2px solid #333;
  border-bottom: 2px solid #333;
  padding: 10px 0;
}

#printing .order-details span {
  font-weight: bold;
  font-size: 15px;
  color: #999;
  text-align: center;
  line-height: 26px;
}


#printing .order-items-wrapper .header {
  font-weight: bold;
  font-size: 12px;
  color: #999;
  text-align: left;
  border-top: none;
}

#printing .packaging-text {
  font-size: 11px;
  color: #666;
  font-weight: normal;
  font-style: italic;
}

#printing .amount {
  text-align: right;
  font-weight: bold;
  color: #000;
}

#printing .total {
  font-weight: bold;
  padding-top: 20px;
  height: 50px;
}

#printing .page-break {
  page-break-after: always;
}
`
		}
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.code
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	mounted: async function() {
		this.getBrands()

		this.d = new Printd()

		const { contentWindow } = this.d.getIFrame()

		contentWindow.addEventListener('beforeprint', () => 'before print event!')

		contentWindow.addEventListener('afterprint', () => 'after print event!')
	},

	watch: {
		fromDate: function(data) {
			this.minDate = data
			this.toDate = new Date()
		},

		exportType: function(data) {
			if (data == 'outstanding') {
				this.displayBrand = false
			} else {
				this.displayBrand = true
			}
		}
	},

	methods: {
		getItemAmount: function(item, clean = false) {
			if (item.price < 2) {
				if (clean) {
					return item.product.price
				} else {
					return item.product.price.toLocaleString('en-GB')
				}
			} else {
				if (clean) {
					return item.price
				} else {
					return item.price.toLocaleString('en-GB')
				}
			}
		},

		getTotalAmount: function(item, clean = false) {
			if (item.price < 2) {
				let itemTotal = item.product.price * item.qty
				if (clean) {
					return itemTotal
				} else {
					return itemTotal.toLocaleString('en-GB')
				}
			} else {
				if (clean) {
					return item.amount
				} else {
					return item.amount.toLocaleString('en-GB')
				}
			}
		},

		// Helper method to get packaging selection with fallback
		getPackagingSelection: function(item) {
			// Check if packaging_selection exists and has value, otherwise return 'single_item'
			if (item && item.packaging_selection && item.packaging_selection.trim() !== '') {
				return item.packaging_selection
			}
			return 'single_item'
		},

		// Helper method to check if PO is warehouse to supplier type
		isWarehouseToSupplier: function(purchaseOrder) {
			return purchaseOrder && purchaseOrder.type === 'warehouse_to_supplier'
		},

		// Helper method to get location name (shop or warehouse)
		getLocationName: function(purchaseOrder) {
			if (this.isWarehouseToSupplier(purchaseOrder)) {
				return purchaseOrder.warehouse ? purchaseOrder.warehouse.name : 'N/A'
			} else {
				return purchaseOrder.shop ? purchaseOrder.shop.name : 'N/A'
			}
		},

		// Helper method to get location type label
		getLocationLabel: function(purchaseOrder) {
			return this.isWarehouseToSupplier(purchaseOrder) ? 'WAREHOUSE' : 'SHOP'
		},

		exportMultiplePo: async function() {
			this.multiplePo = []
			this.poList = []
			this.progress = 0

			if ((this.exportType == 'all' && this.selectedBrand == null) || this.fromDate == null || this.toDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Brand or Starting date is required'
				})
				return
			}

			var data = {
				limit: 100,
				time: {
					createdAt: {
						$gte: this.$moment(this.fromDate)
							.set({ hour: 0 })
							.format('x'),
						$lte: this.$moment(this.toDate)
							.set({ hour: 23 })
							.format('x')
					}
				}
			}

			// If export type is all, add brand
			if (this.exportType == 'all') {
				data.brand = this.selectedBrand._id
			} else {
				data.status = true
			}

			this.isLoading = true

			const getPoList = await this.$api.getMultiPo({ data })

			if (getPoList && getPoList.data) {
				getPoList.data.list.map(po => {
					this.poList.push(po)
				})
			}

			if (getPoList.data.total > 100) {
				let totalLoop = Math.ceil(getPoList.data.total / 100)

				var i
				var skip

				for (i = 1; i < totalLoop; i++) {
					skip = i * 100

					data.skip = skip

					const poList = await this.$api.getMultiPo({ data })

					if (poList && poList.data) {
						poList.data.list.map(po => {
							this.poList.push(po)
						})
					}
				}
			}

			// Loop every PO
			if (getPoList !== undefined && getPoList.data.count > 0) {
				// this.poList.map(async po => {
				let processCount = 0
				for (const po of this.poList) {
					processCount++
					this.progress = (processCount / this.poList.length) * 100

					data = {
						code: po.code,
						populate_purchase_order: ['supplier', 'shop', 'brand', 'warehouse'],
						populate_purchase_order_item: ['product']
					}

					const apiGetPoDetails = await this.$api.getPoDetail({ data })

					if (apiGetPoDetails !== undefined) {
						const poDetail = apiGetPoDetails.data

						poDetail.orderTotal = 0
						poDetail.totalQuantity = 0

						apiGetPoDetails.data.purchase_order_items.map(item => {
							if (item.product.original_price < 2) {
								let itemAmount = item.product.price * item.qty
								apiGetPoDetails.data.orderTotal += itemAmount
							} else {
								apiGetPoDetails.data.orderTotal += item.amount
							}

							apiGetPoDetails.data.totalQuantity += item.qty
						})

						// poDetails.push(poDetail)
						this.multiplePo.push(poDetail)
					}
					// })
				}
			} else {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Nothing found'
				})
			}

			this.isLoading = false
		},

		status: function(po_details) {
			if (po_details.disable == true) {
				// For disabled
				return 'DISABLED'
			} else if (po_details.status == false) {
				// For PI Issued
				return 'CLOSED'
			} else if (po_details.status == true) {
				// For OPEN
				return 'OPEN'
			}
		},

		export_csv: function() {
			let csv = ''

			// Updated CSV header to include PACKAGING column after QUANTITY and generic LOCATION column
			csv += 'ORDER ID,ORDER DATE,EXPECTED DATE,STATUS,BRAND,LOCATION,PRODUCT NAME,BD CODE,BARCODE,PRICE,QUANTITY,PACKAGING,AMOUNT\r\n'

			this.multiplePo.map(po => {
				let po_details = po.purchase_order

				po.purchase_order_items.map(item => {
					let product = item.product

					const toAdd = [
						po_details.code,
						this.convertTime(item.order_date),
						this.convertTime(item.expected_date),
						this.status(po_details),
						po_details.brand.name,
						this.getLocationName(po_details),
						'"' + product.name + '"',
						product.bd_code,
						product.barcode,
						this.getItemAmount(item, true),
						item.qty,
						this.getPackagingSelection(item), // Add packaging selection
						this.getTotalAmount(item, true)
					]

					let row = toAdd.join(',')

					csv += row + '\r\n'
				})

				// Updated totals row to account for new PACKAGING column (add one more comma)
				csv += ',,,,,,,,,,' + po.totalQuantity + ',,' + po.orderTotal
				csv += '\r\n\r\n'
			})

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Export_Purchase_Order_' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()
		},

		exportPo: async function() {
			this.multiplePo = []
			if (this.poCode == null || this.poCode == '') {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Please enter PO Code'
				})

				return
			}

			const data = {
				code: this.poCode,
				populate_purchase_order: ['supplier', 'shop', 'brand', 'warehouse'],
				populate_purchase_order_item: ['product']
			}

			const apiGetPoDetails = await this.$api.getPoDetail({ data })

			if (apiGetPoDetails !== undefined) {
				apiGetPoDetails.data.orderTotal = 0
				apiGetPoDetails.data.totalQuantity = 0

				apiGetPoDetails.data.purchase_order_items.map(item => {
					if (item.product.original_price < 2) {
						let itemAmount = item.product.price * item.qty
						apiGetPoDetails.data.orderTotal += itemAmount
					} else {
						apiGetPoDetails.data.orderTotal += item.amount
					}

					apiGetPoDetails.data.totalQuantity += item.qty
				})

				console.log(apiGetPoDetails)

				this.multiplePo.push(apiGetPoDetails.data)
			} else {
				this.multiplePo = []
			}
		},

		getBrands: async function() {
			const data = {
				limit: 2000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
			}
		},

		print: function() {
			this.d.print(document.getElementById('printing'), [this.cssText])
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YYYY')
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
